define('presentation/settings/callQueues/viewModels/callQueuesViewModel',[
    'common/collections/collectionFilter',
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'common/storage/commonState',
    'presentation/common/actionModal/viewModels/actionModalViewModel',
    'presentation/common/actionModal/viewModels/deleteCallQueueActionViewModel',
    'presentation/common/warningModal/viewModels/warningModalViewModel',
    'presentation/settings/callQueues/facades/callQueuesFacade',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const DeleteCallQueueActionViewModelConstructor = require('presentation/common/actionModal/viewModels/deleteCallQueueActionViewModel');
        const FilterConstructor = require('common/collections/collectionFilter');
        const SorterConstructor = require('common/collections/collectionSorter');

        const _commonState = require('common/storage/commonState');
        const _navigationConfiguration = require('settings/navigationConfiguration');

        let _facade = null;

        const DELETE_RESPONSE = "yes";

        const _buildDeleteModal = (callQueue) => {
            const displayType = _commonState.typeDisplay.callQueue;
            const constructorParams = [callQueue];
            self.actionModal
                .clearModal()
                .setContentViewModel(DeleteCallQueueActionViewModelConstructor, constructorParams)
                .setHeaderText({i18n: {key: 'deleteHeader', options: {type: displayType}}})
                .setSubmitButtonText({i18n: 'delete'});
        };

        // The queue is still wired into a callflow, so nothing was deleted. Said plainly rather
        // than listed as conflicts, because the server reports only that it is routed to, not by
        // what.
        const _showInUsePrompt = () => {
            const displayType = _commonState.typeDisplay.callQueue;
            self.warningModal
                .clearModal()
                .setIcon({icon: 'signupWarning'})
                .setHeading({i18n: {key: 'callQueues:deleteHeading', options: {type: displayType}}})
                .addText({i18n: 'callQueues:inUseByCallflow'})
                .addButton({i18n: 'callQueues:ok', key: 'ok'});

            self.warningModal.showModal();
        };

        const _deleteCallQueue = (callQueue) => {
            _facade.deleteCallQueue(callQueue.accountCallQueueId)
                .done((isUsedByCallflow) => {
                    if (isUsedByCallflow) {
                        _showInUsePrompt();
                        return;
                    }

                    self.availableCallQueues.remove(callQueue);
                })
                .fail((error) => {
                    error.accountCallQueueId = callQueue.accountCallQueueId;
                    throw error;
                });
        };

        const _getCallQueues = () => {
            _facade.getCallQueues()
                .done((callQueues) => {
                    self.availableCallQueues(callQueues);
                });
        };

        self.actionModal = null;
        self.warningModal = null;
        self.isCompositionComplete = ko.observable(false);
        self.addCallQueueUrl = _navigationConfiguration.routesById.newCallQueue.url;
        self.availableCallQueues = ko.observableArray([]);

        self.filteredCallQueues = ko.pureComputed(() => {
            const filterContent = self.searchFilter();
            const availableCallQueues = self.availableCallQueues();

            if (filterContent === '') {
                return availableCallQueues;
            }

            const callQueueFilter = new FilterConstructor();
            callQueueFilter.addProperty('name');
            callQueueFilter.addValue(filterContent);
            return callQueueFilter.filter(availableCallQueues);
        });

        self.displayCallQueues = ko.pureComputed(() => {
            const sortableCallQueues = self.filteredCallQueues();
            const sorter = new SorterConstructor();
            if (sorter.setOptions(self.sortOptions(), self.sortType())) {
                sorter.sort(sortableCallQueues);
            }
            return sortableCallQueues;
        });

        self.sortOptions = ko.observableArray([
            {textI18n: "name", iconName: 'sortName', sortPath: "name", isAscending: true},
            {textI18n: "recentlyAdded", iconName: 'sortRecentlyAdded', sortPath: "createdDateTime.sortValue", isAscending: false},
            {textI18n: "recentlyModified", iconName: 'sortRecentlyModified', sortPath: "modifiedDateTime.sortValue", isAscending: false}
        ]);
        self.sortType = ko.observable("name");
        self.searchFilter = ko.observable('');

        self.showResults = ko.pureComputed(() => self.displayCallQueues().length > 0);
        self.emptyStateContentKey = ko.pureComputed(() => self.availableCallQueues().length > 0 ? "noResults" : "noCallQueues");

        self.poolSummaryI18nKey = (callQueue) => {
            return {
                key: 'poolSummary',
                options: {
                    count: callQueue.poolCount,
                    maxCallers: callQueue.maxCallersInQueue
                }
            };
        };

        self.launchDeleteCallQueue = (callQueue) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _buildDeleteModal(callQueue);
                self.actionModal.showModal()
                    .done((result) => {
                        if (result === DELETE_RESPONSE) {
                            _deleteCallQueue(callQueue);
                        }
                        promise.resolve();
                    })
                    .fail((error) => {
                        throw error;
                    });
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/callQueues/facades/callQueuesFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
            self.actionModal = new ActionModalViewModelConstructor();

            const WarningModalViewModelConstructor = require('presentation/common/warningModal/viewModels/warningModalViewModel');
            self.warningModal = new WarningModalViewModelConstructor();

            return _initialize();
        };

        const _initialize = () => {
            _getCallQueues();

            return _promiseFactory.wait();
        };
    };
});

